import { Component, OnInit, Input } from '@angular/core';
import { Course, CourseService } from 'src/app/core/http/course/course.service';
import { TitleAndCrumbServiceService } from '../../services/title/title-and-crumb-service.service';

@Component({
  selector: 'courses-list',
  templateUrl: './courses-list.component.html',
  styleUrls: ['./courses-list.component.css']
})
export class CoursesListComponent implements OnInit {
  @Input() privateCourse;
  courses: Course[];

  constructor(private CourseService: CourseService) {

  }

  ngOnInit() {
    this.getCourses();
  }

  getCourses() {
    if(this.privateCourse) {
      this.CourseService.getAllStarted()
      .subscribe(resp => {
        this.courses = resp;
      });
    } else {
      this.CourseService.getAll()
      .subscribe(resp => {
        this.courses = resp;
        console.log(this.courses)
      });
    }
    
  }

}
